module.exports = __webpack_public_path__ + "static/media/I_submit_to_the_hypno_virus.728ef456.mp3";